import React, { Component } from "react";
import classNames from "classnames";
import {
  getAttendanceModeCodesDetails,
  getAttendanceModeDescription,
} from "../../services/vu";
import { Link } from '@mui/icons-material'

const gen_url =
  "https://www.vu.edu.au/vu-english/english-language-courses/general-english";
const eap_url =
  "https://www.vu.edu.au/vu-english/english-language-courses/english-for-academic-purposes-eap";

class Unit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      focused: false,
      attendanceModeList: [],
    };
  }

  componentDidMount() {
    Promise.all([getAttendanceModeCodesDetails()]).then(
      ([attendanceModeList]) => {
        this.setState({
          attendanceModeList: attendanceModeList.referenceCodes,
        });
      },
    );
  }

  render() {
    var unitcode = this.props.code
    var unit_details_url = unitcode.indexOf('GEN') != -1 ? gen_url : unitcode.indexOf('EAP') != -1 || unitcode.indexOf('IEL') != -1 ? eap_url : `https://www.vu.edu.au/units/${unitcode}`

    return (
      <div className={classNames('unit-container', { 'unit-container--focused': this.state.focused }, { 'unit-container--virtual': this.props.virtual })}>
        <div className={classNames('unit', 'unit-front', { 'unit-core': this.props.core }, { 'unit-prerequisite': this.props.hasRequisite })}>
          <h3 className="unit-code">{this.props.code}</h3>
          {/* <p className="credit-points">{this.props.creditPoints}</p> */}
          <p className="credit-points-container">
            {this.props.hasRequisite ? (
              <span className="icon-prerequisite">
                <Link /> &nbsp; |
              </span>
            ) : null}
            
            <span className='credit-points'>{this.props.creditPoints}</span>  
          </p>
          <p className="unit-name">{this.props.name}</p>
          <p className="unit-attendance-mode">
            <span>{getAttendanceModeDescription(this.state.attendanceModeList, this.props.attendanceMode)}</span>
          </p>
          <p className="unit-campus">{this.props.campus}</p>
        </div>
        <div
          className={classNames('unit', 'unit-back', {
            'unit-core': this.props.core
          })}
        >
          <a onFocus={() => this.setState({ focused: true })} onBlur={() => this.setState({ focused: false })} className="btn" href={unit_details_url} target="_blank">
            Unit details
          </a>
        </div>
      </div>
    )
  }
}

export default Unit;
